// extracted by mini-css-extract-plugin
export default {"rootPassword":"password_rootPassword__tNDVr","divHomeButton":"password_divHomeButton__TLwWb"};